var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn_box"},[_c('el-button',{staticClass:"sys-btn-default",staticStyle:{"margin-right":"20px"},attrs:{"size":"small"},on:{"click":_vm.goBackClick}},[_vm._v(_vm._s(_vm.$t('common.cancel')))]),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.handleSave}},[_vm._v(_vm._s(_vm.$t('common.confirm')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }